import {
  BEFORE_AND_AFTER_SUNO_FEATURE,
  DASHBOARD_DESIGN_V2_FEATURE,
  DIRECT_MAIL_DASHBOARD_FEATURE,
  PRACTICE_USAGE_FEATURE,
  QUICKBOOKS_DASHBOARD_FEATURE,
  SCHEDULING_DASHBOARD_VIEW
} from "constants/feature-flags";

import inSection from "./in-section.util";

export const DASHBOARD_DESTINATIONS = inSection("/dashboard", [
  { to: "ai-insights", label: "AI Insights" },
  { to: "finances", label: "Finances" },
  { to: "devices", label: "Devices" },
  {
    to: "scheduling",
    label: "Scheduling",
    featureFlag: SCHEDULING_DASHBOARD_VIEW
  },
  { to: "staff", label: "Staff", featureFlag: DASHBOARD_DESIGN_V2_FEATURE },
  {
    to: "practice-usage",
    label: "Practice Usage",
    featureFlag: PRACTICE_USAGE_FEATURE
  },
  {
    to: "before-and-after-suno",
    label: "Before and After Suno",
    featureFlag: BEFORE_AND_AFTER_SUNO_FEATURE
  },
  {
    to: "quickbooks-finances",
    label: "QBO Finances",
    keywords: ["quickbooks"],
    featureFlag: QUICKBOOKS_DASHBOARD_FEATURE,
    when: ({ currentPractice }) =>
      Boolean(currentPractice?.is_quickbooks_enabled)
  },
  {
    to: "direct-mail",
    label: "Direct Mail",
    featureFlag: DIRECT_MAIL_DASHBOARD_FEATURE,
    when: ({ currentPractice }) => Boolean(currentPractice?.direct_mail_enabled)
  }
]);
